var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.93539C15.001 7.78591 14.9709 7.63786 14.9116 7.50065C14.8523 7.36345 14.765 7.24011 14.6554 7.13846L8.00002 1L1.34464 7.13846C1.23504 7.24011 1.14779 7.36345 1.08846 7.50065C1.02913 7.63786 0.999013 7.78591 1.00002 7.93539V13.9231C1.00002 14.2087 1.11349 14.4826 1.31545 14.6846C1.51741 14.8865 1.79133 15 2.07695 15H13.9231C14.2087 15 14.4826 14.8865 14.6846 14.6846C14.8866 14.4826 15 14.2087 15 13.9231V7.93539Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15V10.6923",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e8b117fede89484eb2747f6ba2f3692f.svg";
export { ForwardRef as ReactComponent };